export default "__VITE_ASSET__9a49945c__"